import { render, staticRenderFns } from "./TaskAttachmentsDialog.vue?vue&type=template&id=105b9fc7&scoped=true"
import script from "./TaskAttachmentsDialog.vue?vue&type=script&lang=ts"
export * from "./TaskAttachmentsDialog.vue?vue&type=script&lang=ts"
import style0 from "./TaskAttachmentsDialog.vue?vue&type=style&index=0&id=105b9fc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105b9fc7",
  null
  
)

export default component.exports